import myMoney from '../assets/svgProjects/myMoney.svg'
import social from '../assets/svgProjects/social.svg'
import todolist from '../assets/svgProjects/todolist.svg'
import cards from '../assets/svgProjects/cards.svg'
import inctagram from '../assets/svgProjects/inctagram.svg'


export const svgProjects = {
    myMoney,
    social,
    todolist,
    cards,
    inctagram
}